import { render, staticRenderFns } from "./TabellaFermi.vue?vue&type=template&id=97cc63f4&scoped=true&"
import script from "./TabellaFermi.vue?vue&type=script&lang=js&"
export * from "./TabellaFermi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cc63f4",
  null
  
)

export default component.exports